<template>
  <div class="location-screen">
    <div class="back-button">
      <el-button @click="navigateBack">
        返回主屏幕
      </el-button>
    </div>
    
    <div class="screen-title">
      位置管理
    </div>
    
    <el-row
      :gutter="20"
      class="data-cards"
    >
      <el-col :span="8">
        <el-card class="data-card">
          <h3>小区总数</h3>
          <div class="big-number">
            125
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="data-card">
          <h3>楼栋总数</h3>
          <div class="big-number">
            1234
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="data-card">
          <h3>单元总数</h3>
          <div class="big-number">
            5678
          </div>
        </el-card>
      </el-col>
    </el-row>
    
    <el-row
      :gutter="20"
      class="charts-row"
    >
      <el-col :span="24">
        <el-card class="chart-card">
          <h3>社区地图分布</h3>
          <div class="chart-container">
            <div ref="communityMapChart" />
          </div>
        </el-card>
      </el-col>
    </el-row>
    
    <el-row
      :gutter="20"
      class="charts-row"
    >
      <el-col :span="12">
        <el-card class="chart-card">
          <h3>小区分布统计</h3>
          <div class="chart-container">
            <div ref="communityDistributionChart" />
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="chart-card">
          <h3>楼层分布</h3>
          <div class="chart-container">
            <div ref="floorDistributionChart" />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

// ... existing code ...
<script>
import { ref, onMounted, nextTick } from 'vue' // 调整导入
import { useRouter } from 'vue-router'
import * as echarts from 'echarts'

export default {
  name: 'LocationScreen',
  setup() {
    const router = useRouter()
    const communityMapChart = ref(null)
    const communityDistributionChart = ref(null)
    const floorDistributionChart = ref(null)
    
    console.log('组件初始化 - 开始')
    console.log('ECharts版本:', echarts.version)
    
    const navigateBack = () => {
      router.push({ name: 'MainDashboard' })
    }
    
    // 添加强制初始化图表函数
    const forceInitChart = (chartRef, option) => {
      if (!chartRef.value) {
        console.error('图表容器不存在')
        return null
      }
      
      // 检查容器尺寸
      const container = chartRef.value
      const rect = container.getBoundingClientRect()
      
      // 如果尺寸为0，尝试强制设置尺寸
      if (rect.width === 0 || rect.height === 0) {
        console.warn('图表容器尺寸为0，尝试强制设置尺寸')
        container.style.width = '100%'
        container.style.height = '300px'
        // 重新获取尺寸
        const newRect = container.getBoundingClientRect()
        if (newRect.width === 0 || newRect.height === 0) {
          console.error('强制设置尺寸后仍无效，创建临时div')
          // 创建临时div作为备选容器
          const tempDiv = document.createElement('div')
          tempDiv.style.width = '100%'
          tempDiv.style.height = '300px'
          document.body.appendChild(tempDiv)
          const chartInstance = echarts.init(tempDiv)
          chartInstance.setOption(option)
          // 延迟移除临时div
          setTimeout(() => {
            document.body.removeChild(tempDiv)
          }, 1000)
          return chartInstance
        }
      }
      
      // 正常初始化图表
      const chartInstance = echarts.init(container)
      chartInstance.setOption(option)
      
      // 添加窗口大小变化监听
      window.addEventListener('resize', () => {
        chartInstance.resize()
      })
      
      return chartInstance
    }
    
    // 移除原有的 watchEffect 和 onMounted 代码，替换为优化后的初始化逻辑
    onMounted(() => {
      console.log('组件已挂载 - 开始初始化图表')
      // 使用 requestAnimationFrame 和 nextTick 确保DOM已准备好
      requestAnimationFrame(() => {
        nextTick(() => {
          // 初始化社区地图图表
          forceInitChart(communityMapChart, {
            backgroundColor: 'transparent',
            tooltip: { trigger: 'axis' },
            xAxis: {
              type: 'category',
              data: ['北京', '上海', '广东', '江苏', '浙江'],
              axisLabel: { color: '#fff' },
              axisLine: { lineStyle: { color: 'rgba(255,255,255,0.3)' } }
            },
            yAxis: {
              type: 'value',
              axisLabel: { color: '#fff' },
              axisLine: { lineStyle: { color: 'rgba(255,255,255,0.3)' } },
              splitLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } }
            },
            series: [{
              name: '社区数量',
              data: [20, 15, 30, 25, 15],
              type: 'bar',
              itemStyle: { color: '#409EFF' }
            }]
          })
          
          // 初始化小区分布图表
          forceInitChart(communityDistributionChart, {
            tooltip: { trigger: 'axis' },
            xAxis: { type: 'category', data: ['大型小区(>1000户)', '中型小区(500-1000户)', '小型小区(<500户)'] },
            yAxis: { type: 'value' },
            series: [{ data: [25, 50, 50], type: 'bar' }]
          })
          
          // 初始化楼层分布图表
          forceInitChart(floorDistributionChart, {
            tooltip: { trigger: 'item' },
            series: [{
              name: '楼层分布',
              type: 'funnel',
              data: [
                { value: 500, name: '6-10层' },
                { value: 300, name: '11-20层' },
                { value: 234, name: '21层以上' },
                { value: 200, name: '1-5层' }
              ],
              itemStyle: {
                color: function(params) {
                  const colorList = ['#1E3A8A', '#2563EB', '#3B82F6', '#60A5FA']
                  return colorList[params.dataIndex]
                }
              }
            }]
          })
        })
      })
    })
    
    return {
      communityMapChart,
      communityDistributionChart,
      floorDistributionChart,
      navigateBack
    }
  }
}
</script>
// ... existing code ...

<style scoped>
.location-screen {
  background-color: #000000;
  color: white;
  padding: 20px;
  min-height: 100vh;
  box-sizing: border-box;
}

.screen-title {
  font-size: 32px;
  font-weight: bold;
  color: white;
  letter-spacing: 2px;
  text-align: center;
  margin-bottom: 20px;
}

.back-button {
  margin-bottom: 20px;
  text-align: left;
}

.back-button .el-button {
  background: linear-gradient(135deg, #122a44, #0a1a2a);
  border: none;
  color: white;
}

.data-cards {
  margin-bottom: 20px;
}

.data-card {
  border: none;
  border-radius: 4px;
  background: linear-gradient(135deg, #122a44, #0a1a2a);
  background-image: 
    radial-gradient(circle at 30% 30%, rgba(24, 144, 255, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 70% 70%, rgba(24, 144, 255, 0.1) 0%, transparent 40%);
  color: white;
  text-align: center;
  padding: 15px;
  box-sizing: border-box;
}

.big-number {
  font-size: 36px;
  font-weight: bold;
  margin: 20px 0;
}

.charts-row {
  margin-bottom: 20px;
}

.chart-card {
  border: none;
  border-radius: 4px;
  background: linear-gradient(135deg, #122a44, #0a1a2a);
  background-image: 
    radial-gradient(circle at 30% 30%, rgba(24, 144, 255, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 70% 70%, rgba(24, 144, 255, 0.1) 0%, transparent 40%);
  color: white;
  padding: 15px;
  box-sizing: border-box;
}

.chart-container {
  width: 100% !important;
  height: 300px !important; /* 保持现有高度，但增强其他属性 */
  min-height: 300px !important;
  box-sizing: border-box !important;
  position: relative !important;
  overflow: hidden !important;
}

/* 添加额外的样式覆盖，确保 Element UI 卡片不影响图表容器 */
:deep(.chart-card .el-card__body) {
  height: 100%;
  padding: 15px !important;
  box-sizing: border-box;
}
</style>